import { CreateProcedure } from '../entity';
import ProcedureFormDialog from './procedure-consumption-form-dialog';
import AddSaleItemsButton from './procedure-sales-form-dialog';

type ProcedureActionsProps = {
  hasNoProcedures: boolean;

  isVisitClosed: boolean;
  isSubscriptionExpert: boolean;
  proceduresByType: {
    sale: CreateProcedure[];
    consumption: CreateProcedure[];
  };
};

const ProcedureActions = ({
  hasNoProcedures,
  isVisitClosed,
  isSubscriptionExpert,
  proceduresByType,
}: ProcedureActionsProps) => {
  return (
    <>
      <ProcedureFormDialog
        hasNoProcedures={hasNoProcedures}
        isVisitClosed={isVisitClosed}
        procedures={proceduresByType.consumption}
      />
      {isSubscriptionExpert && (
        <AddSaleItemsButton isVisitClosed={isVisitClosed} procedures={proceduresByType.sale} />
      )}
    </>
  );
};
export default ProcedureActions;
